export default __webpack_public_path__ + "static/css/cms-editor.min.css";